import get from "lodash/get";

export const validateStepKey = stepKey => {
  if (!/^([0-9]+|invite|complete|new|sample)$/.test(stepKey || "")) return "";
  return stepKey;
};
export const getStepKey = props => {
  return validateStepKey(props.stepKey || get(props, "match.params.step"));
};

const pathForStep = (section, step) => `/onboarding/${section}/${step}`;
const defineStepForSection = ({ sectionName, orderedSteps, prefix }) => {
  const maxStep = orderedSteps.length;
  return name => {
    const i = orderedSteps.indexOf(name);
    const indexed = i >= 0;
    const stepKey = indexed ? i + 1 : name.toLowerCase();
    const previousKey = i > 0 && i;
    const previous = previousKey && {
      stepKey: previousKey,
      stepPath: pathForStep(sectionName, previousKey),
    };
    const nextKey =
      indexed && (stepKey + 1 > maxStep ? "complete" : stepKey + 1);
    const next = nextKey && {
      stepKey: nextKey,
      stepPath: pathForStep(sectionName, nextKey),
    };
    return {
      fullName: `AppOptics ${prefix}${name}`,
      name,
      next,
      previous,
      stepKey: `${stepKey}`,
      stepPath: pathForStep(sectionName, stepKey),
      sectionName,
    };
  };
};
export const defineOnboardingSection = sectionProps => {
  const defineStep = defineStepForSection(sectionProps);
  const byName = {};
  const byKey = {};
  const byFullName = {};
  sectionProps.steps.forEach(name => {
    const step = defineStep(name);
    byName[name] = step;
    byKey[step.stepKey] = step;
    byFullName[step.fullName] = step;
  }, {});
  const maxStep = sectionProps.orderedSteps.length;
  return { byName, byKey, byFullName, maxStep };
};
